import React from 'react'

const PieChart = ({ length, color, playhead }) => {
    // Ensure the length is within valid bounds
    const numSides = length >= 0 ? length : 0

    // Calculate the percentage of the pie chart to be filled based on playhead
    let fillPercentage = (playhead + 1 % length) / length

    if (numSides === 1) {
        return (
            <svg width={'128px'} height={'128px'}>
                <circle cx="64" cy="64" r="32" fill={color} />
            </svg>
        )
    }

    /*// If playhead is -1, fill the entire polygon
    if (playhead === -1) {
        fillPercentage = 1
    }*/

    // Calculate the angle for each side of the polygon
    const angle = 360 / numSides

    // Calculate the radius of the circle
    const radius = 64

    // Calculate the coordinates for each vertex of the polygon
    const points = []
    for (let i = 0; i < numSides; i++) {
        const x = 64 + radius * Math.cos(((i * angle - 90) * Math.PI) / 180)
        const y = 64 + radius * Math.sin(((i * angle - 90) * Math.PI) / 180)
        points.push(`${x},${y}`)
    }

    // Construct the polygon points string
    const pointsString = points.join(' ')

    // Calculate the points for the filled portion of the pie chart
    const filledPoints = []
    filledPoints.push(`64,64`) // Start from the center
    for (let i = 0; i <= Math.ceil(fillPercentage * numSides); i++) {
        const x = 64 + radius * Math.cos(((i * angle - 90) * Math.PI) / 180)
        const y = 64 + radius * Math.sin(((i * angle - 90) * Math.PI) / 180)
        filledPoints.push(`${x},${y}`)
    }

    // Construct the filled portion polygon points string
    const filledPointsString = filledPoints.join(' ')

    return (
        <svg width={'128px'} height={'128px'}>
            <polygon points={pointsString} stroke={color} strokeWidth="2" fill="none" />
            <polygon points={filledPointsString} fill={color} />
        </svg>
    )
}

export default PieChart